<div class="button-toggle-container">
    <span class="mat-caption">{{ labelT | translate }}</span>
    <mat-button-toggle-group [formControlName]="controlKey" class="language-toggle">
        <mat-button-toggle value="Active">
            {{ 'users.active' | translate }}
          </mat-button-toggle>
          <mat-button-toggle value="Inactive">
            {{ 'users.inactive' | translate }}
          </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
